export const filterOptionsConst = {
  DELETE: 'delete',
  PAID: 'Pagada',
  APPROVE: 'Aprobado'
};
